module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAAXNSR0IArs4c6QAAAEVJREFUOBFj+M/AEArEqxioAGBmMVHBLAwjRg3FCBKKBUbDlOIgxDBgNEwxgoRigdEwpTgIMQygSZiyQK0BVSlARBWwGgDqOgkhWi5bvAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/auto suspend.png
// module id = 106
// module chunks = 7